import { createApp } from 'vue'
import IbanValidator from './IbanValidator.vue'
import './assets/global.css'

createApp(IbanValidator).mount('#iban')
